import { useContext } from "react";
import { CatalogContext } from "./CatalogContext";
import { apply, getFilters } from "./filter";

export function useFilter(
  value: Record<string, number>,
  options?: Array<Catalog.Options>
) {
  const { oois } = useContext(CatalogContext);

  if (!options) {
    return oois;
  }

  const selectedOptions = options.map(({ name, values }) => ({
    name,
    value: name in value ? values[value[name]] : null,
  }));
  const filters = getFilters(selectedOptions);
  return oois.filter(apply(filters));
}
